import ConnectorViewMapping from '../../../../components/connector_views/connector_mapping'

const ConnectorViewEditMappings = () => {

  return <ConnectorViewMapping />
}

export default ConnectorViewEditMappings
